export function removeFromArray(id, data) {
  let index = data.findIndex(x => x.id === id);
  let newData = [...data];
  if (index !== -1) {
    newData.splice(index, 1);
    return newData;
  }
}